module.exports = __webpack_public_path__ + "img/disc.ffb63f23.svg";